<template>
    <div class="number-input-container mb-3">
      <label>
        <question-display :question="question" customClass="header-number-input" />
      </label>
      <div class="form-inline">
        <input
          type="number"
          v-model.number="inputValue"
          :placeholder="'value'"
          class="form-control i1"
          min="0"
          @input="updateAnswer"
        />
        <select v-model="inputType" class="form-control form-select i2" @change="updateAnswer">
          <option value="days">Days</option>
          <option value="month">Months</option>
        </select>
      </div>
      <small v-if="showValidation && !isValidInput()" class="text-danger">{{ errorMsg }}</small>
    </div>
  </template>
  
  
  <script>
import surveyService from '@/services/surveyService';
import QuestionDisplay from '../utils/QuestionDisplay.vue';

export default {
  components: {
    QuestionDisplay
  },
  props: {
    question: Object,
    showValidation: Boolean
  },
  data() {
    const answer = surveyService.getAnswer(this.question.id);
    return {
      inputValue: answer?.value ?? '',
      inputType: answer?.type ?? 'days',
      errorMsg: ''
    };
  },
  methods: {
    updateAnswer() {
      const finalAnswer = {
        value: this.inputValue,
        type: this.inputType
      };
      surveyService.setAnswer(this.question.id, finalAnswer);
      this.$emit('input', finalAnswer);
    },
    isValidInput() {
      this.errorMsg = '';

      if (this.question.required && (this.inputValue === '' || this.inputValue === null)) {
        this.errorMsg = 'This field is required.';
        return false;
      }

      if (this.inputValue < 0) {
        this.errorMsg = 'Value must be a positive number.';
        return false;
      }

      return true;
    }
  },
  watch: {
    question(newQuestion) {
      const answer = surveyService.getAnswer(newQuestion.id);
      this.inputValue = answer?.value ?? '';
      this.inputType = answer?.type ?? 'days';
    }
  }
};
</script>

  <style scoped>
    /* Remove spinner arrows in number input (Chrome, Safari, Edge) */
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  
    /* Remove spinner arrows in Firefox */
    input[type=number] {
      -moz-appearance: textfield;
    }
  </style>
  